module.exports = __webpack_public_path__ + "static/img/denys-nevozhai-7nrsVjvALnA-unsplash_thumb.6e3f514.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/denys-nevozhai-7nrsVjvALnA-unsplash_thumb.png
// module id = ehgl
// module chunks = 4